import fetchApi from 'services/api/connector';

export const getServices = (ws) => fetchApi(`ws/${ws}/services`);

export const createService = (ws, data) => fetchApi(`ws/${ws}/services`, { method: 'POST', data });
